<script setup lang="ts">
import { computed, type PropType } from 'vue';
import type { InputProps } from 'naive-ui';

/**
 * Free text with suggestions: the list filters as you type and a pick fills
 * the field, but whatever is typed is the value — a legal form, say, where the
 * common ones are known and the rest are anything.
 */
const props = defineProps({
  value: { type: String, default: '' },
  suggestions: { type: Array as PropType<string[]>, default: () => [] },
  placeholder: { type: String, default: undefined },
  disabled: { type: Boolean, default: false },
  size: { type: String as PropType<InputProps['size']>, default: undefined },
  status: { type: String as PropType<InputProps['status']>, default: undefined },
  inputProps: { type: Object as PropType<InputProps['inputProps']>, default: undefined },
});

const emit = defineEmits<{ 'update:value': [value: string] }>();

const options = computed(() => {
  const typed = props.value.trim().toLowerCase();
  return props.suggestions
    .filter(suggestion => suggestion.toLowerCase().includes(typed))
    .map(suggestion => ({ label: suggestion, value: suggestion }));
});
</script>

<template>
  <!-- Opens on focus with every suggestion, not only once something is typed. -->
  <n-auto-complete
    :value="props.value"
    :options="options"
    :placeholder="props.placeholder"
    :disabled="props.disabled"
    :size="props.size"
    :status="props.status"
    :input-props="props.inputProps"
    :get-show="() => true"
    @update:value="(value: string | null) => emit('update:value', value ?? '')"
  />
</template>
